"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _pako = _interopRequireDefault(require("pako"));
var _bops = _interopRequireDefault(require("bops"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Print = exports["default"] = /*#__PURE__*/function (_Core) {
  function Print(props) {
    var _this;
    var printerControlsAcceptors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, _classCallCheck2["default"])(this, Print);
    _this = _callSuper(this, Print, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.myServices = ["pps"];
    _this.init(printerControlsAcceptors);
    return _this;
  }
  (0, _inherits2["default"])(Print, _Core);
  return (0, _createClass2["default"])(Print, [{
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this2 = this;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function () {
                var payload = {
                  action: "System.PrintService.CheckReady",
                  uuid: (0, _uuid.v4)(),
                  origin: "sdk-" + _this2.appName,
                  timestamp: +new Date(),
                  request_uuid: "",
                  data: "{}"
                };
                _this2.connection.invoke("messaging", payload).then(function () {
                  _this2.connection.invoke("messaging", payload).then(function () {
                    _this2.connection.on("messaging", function (msg) {
                      if (msg.action === "System.PrintService.Notify.Ready") {
                        if (!_this2.ready) {
                          _this2.ready = true;
                          _this2.trigger("ready", true);
                          _logger["default"].success("Initialization done", "Module is now ready", "Print");
                        }
                      }
                    });
                  })["catch"](function (error) {
                    reject(error);
                  });
                });
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(message) {
        var notification, data, status_change, _data;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.t0 = message.action;
              _context2.next = _context2.t0 === 'System.SDK.ServiceNotification.Response' ? 5 : _context2.t0 === "System.PrintService.StatusNotifications" ? 11 : _context2.t0 === 'System.ServiceNotification' ? 14 : 22;
              break;
            case 5:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return");
            case 7:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
              }
              return _context2.abrupt("return");
            case 11:
              status_change = JSON.parse(message.data);
              this.trigger("statusChange", status_change);
              return _context2.abrupt("return");
            case 14:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context2.next = 16;
                break;
              }
              return _context2.abrupt("return");
            case 16:
              // Send our data
              _data = JSON.parse(message.data);
              _context2.next = 19;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(_data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 19:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context2.abrupt("return");
            case 22:
              return _context2.abrupt("break", 23);
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this3 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this3.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "getPrinters",
    value: function getPrinters() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "System.PrintService.GetPrinters",
          uuid: (0, _uuid.v4)(),
          requestUuid: "",
          origin: "sdk-" + _this4.appName,
          data: "{}"
        };
        _this4.connection.invoke("messaging", payload).then(function () {
          _this4.connection.on("messaging", function (msg) {
            if (msg.action === "System.PrintService.GetPrinters.Response") {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "getStatus",
    value: function getStatus(printerName, configIndex) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "System.PrintService.Status",
          requestUuid: "",
          uuid: (0, _uuid.v4)(),
          origin: "sdk-" + _this5.appName
        };
        if (printerName && configIndex) {
          payload.data = JSON.stringify({
            printer_name: printerName,
            config: configIndex
          });
        } else {
          payload.data = "{}";
        }
        _this5.connection.invoke("messaging", payload).then(function () {
          _this5.connection.on("messaging", function (msg) {
            if (msg.action === "System.PrintService.Status.Response") {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "setPrinterStatus",
    value: function setPrinterStatus(faultName, faultState) {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "System.PrintService.SetFault",
          uuid: (0, _uuid.v4)(),
          requestUuid: "",
          origin: "sdk-" + _this6.appName,
          data: JSON.stringify({
            fault_name: faultName,
            fault_state: faultState
          })
        };
        _this6.connection.invoke("messaging", payload).then(function () {
          _this6.connection.on("messaging", function (msg) {
            if (msg.action === "System.PrintService.SetFault.Response") {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "index",
    value: function index() {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "System.PrintService.Index",
          uuid: (0, _uuid.v4)(),
          requestUuid: "",
          origin: "sdk-" + _this7.appName,
          data: "{}"
        };
        _this7.connection.invoke("messaging", payload).then(function () {
          _this7.connection.on("messaging", function (msg) {
            if (msg.action === "System.PrintService.Index.Response") {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "getServiceInfo",
    value: function getServiceInfo() {
      var _this8 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "System.PrintService.ServiceInfo",
          uuid: (0, _uuid.v4)(),
          requestUuid: "",
          origin: "sdk-" + _this8.appName,
          data: "{}"
        };
        _this8.connection.invoke("messaging", payload).then(function () {
          _this8.connection.on("messaging", function (msg) {
            if (msg.action === "System.PrintService.ServiceInfo.Response") {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "addPrintJob",
    value: function addPrintJob(template, printer, config) {
      var _this9 = this;
      return new Promise(function (resolve, reject) {
        // Compress the template if required
        var compressedTemplate = _pako["default"].gzip(template);

        // Assuming bops can handle the Uint8Array directly:
        var base64Template;
        try {
          base64Template = _bops["default"].to(compressedTemplate, 'base64');
        } catch (error) {
          reject(new Error("Failed to convert to Base64: " + error.message));
          return;
        }
        var payload = {
          action: "System.PrintService.AddJob",
          uuid: (0, _uuid.v4)(),
          origin: "sdk-" + _this9.appName,
          requestUuid: "",
          data: JSON.stringify({
            compressed: true,
            template: base64Template,
            printer: printer,
            config: config
          })
        };
        _this9.connection.invoke("messaging", payload).then(function () {
          _this9.connection.on("messaging", function (msg) {
            if (msg.action === "System.PrintService.AddJob.Response") {
              resolve(JSON.parse(msg.data));
            }
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "init",
    value: function init(printerControlsAcceptors) {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Print");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Print");
      } else {
        this.ready = true;
        this.trigger("ready", true);
        this.connection.on("messaging", this.handleMessage.bind(this));
      }
      this.connection.on("messaging", this.handleMessage.bind(this));
      this.getCheckReady();
      // Send the initial message to the dpm with printerControlsAcceptors
      this.connection.invoke('messaging', {
        uuid: (0, _uuid.v4)(),
        action: 'System.PeripheralsManager.PrinterAcceptorsControl',
        origin: 'sdk-' + this.appName,
        data: JSON.stringify({
          printerControlsAcceptors: printerControlsAcceptors
        })
      }).then(function () {
        _logger["default"].info("Initialization", "Sent initial printer control message", "Print");
      })["catch"](function (error) {
        _logger["default"].error("Initialization", "Failed to send initial printer control message", error);
      });
    }
  }]);
}(_core["default"]);